import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { MemberStateService } from '../registration/application/member-state.service';
import { SfappService } from '../../core/services/sfapp.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-payments-result',
    imports: [TranslatePipe],
    template: `
    <div class="main-content">
      <section class="access">
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-xs-12">
              <div class="clearfix"></div>
              <div style="margin: 2rem 0">
                <p style="white-space: pre-line">{{ message }}</p>
              </div>
              <br />
              <div class="text-center">
                <button class="btn-application-1" (click)="goToTop()">{{ 'backToTop' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  `
})
export class PaymentsResultComponent implements OnInit, OnDestroy {
  private readonly unknownMessage = '結果を取得できませんでした。お手数ですが店舗までお問い合わせください。';
  private stateService = inject(MemberStateService);
  private sfapp = inject(SfappService);
  private route = inject(ActivatedRoute);
  private sfTop = environment.sfTopUrl;

  message = this.unknownMessage;

  async ngOnInit(): Promise<void> {
    this.stateService.setBtResult(true);
    const resultId = this.route.snapshot.queryParamMap.get('resultId');
    const memberId = this.route.snapshot.queryParamMap.get('memberId');
    if (!resultId || !memberId) {
      this.message = this.unknownMessage;
      return;
    }

    try {
      this.message = await this.sfapp.getPaymentsReturnResult(resultId, memberId) || this.unknownMessage;
    } catch (e: any) {
      this.message = e?.error?.message || e?.data?.message || this.unknownMessage;
    }
  }

  ngOnDestroy(): void {
    this.stateService.setBtResult(false);
  }

  goToTop(): void {
    window.location.href = this.sfTop;
  }
}
